export default __webpack_public_path__ + "static/media/1-5-4.ba7a4b02.jpg";